export { default as Accounts } from './Accounts';
export { default as CaseStudies } from './CaseStudies';
export { default as ContactUs } from './ContactUs';
export { default as DownloadBrochure } from './DownloadBrochure';
export { default as Faq } from './Faq';
export { default as FreeTrial } from './FreeTrial';
export { default as Hero } from './Hero';
export { default as LearnMore } from './LearnMore';
export { default as New } from './New';
export { default as NewsPage } from './NewsPage';
export { default as OurClients } from './OurClients';
export { default as PriceCards } from './PriceCards';
export { default as Pricing } from './Pricing';
export { default as QuotesSection } from './QuotesSection';
export { default as Samples } from './Samples';
export { default as TaggisAndDocBrowser } from './TaggisAndDocBrowser';
export { default as TextImage } from './TextImage';
export { default as TextOnly } from './TextOnly';
export { default as TrialOffer } from './TrialOffer';
export { default as VideoSection } from './VideoSection';



// WEBPACK FOOTER //
// ./src/components/templates/index.js